import { render, staticRenderFns } from "./process-article-30-radios.vue?vue&type=template&id=1e446050"
import script from "./process-article-30-radios.vue?vue&type=script&lang=js"
export * from "./process-article-30-radios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports